import React, { type MouseEvent, type ReactNode } from "react";

const popupFeatures = [
  "popup=yes",
  "width=1100",
  "height=820",
  "resizable=yes",
  "scrollbars=yes",
].join(",");

export function LegalPopupLink({
  children,
  href,
}: {
  children: ReactNode;
  href: string;
}) {
  const openPopup = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const popup = window.open(href, "asanowharton-legal", popupFeatures);
    if (popup) {
      popup.opener = null;
      popup.focus();
      return;
    }
    window.location.assign(href);
  };

  return (
    <a href={href} onClick={openPopup}>
      {children}
    </a>
  );
}
